import React, { FC } from "react";

import { Box } from "@UI/Components/Box/Box";
import { Flex } from "@UI/Components/Flex/Flex";
import { Skeleton } from "@UI/Components/Skeleton/Skeleton";
import { VStack } from "@UI/Components/Stack/Stack";

export interface PhotoCardSkeletonProps {
  isElevated?: boolean;
}

/**
 * One in-flight upload — same card shape as `PhotoCard`, so the grid doesn't
 * reflow when the real thumbnail and caption field replace it, and so it takes
 * the same elevation as the cards it sits beside.
 */
export const PhotoCardSkeleton: FC<PhotoCardSkeletonProps> = ({
  isElevated = false,
}) => (
  <Box
    background="white"
    borderRadius="10px"
    borderWidth="1px"
    borderColor="gray.200"
    padding="12px"
    boxShadow={isElevated ? "sm" : undefined}
  >
    <Flex gap="12px" alignItems="flex-start">
      <Skeleton boxSize="64px" borderRadius="8px" flexShrink={0} />
      <VStack flex="1" alignItems="stretch" spacing="8px" paddingTop="4px">
        <Skeleton height="10px" width="100%" borderRadius="4px" />
        <Skeleton height="10px" width="100%" borderRadius="4px" />
        <Skeleton height="10px" width="40%" borderRadius="4px" alignSelf="flex-end" />
      </VStack>
    </Flex>
  </Box>
);
